<template>
  <Modal
    :show="show"
    :title="title"
    :dialogMaxWidth="dialogMaxWidth"
    :closeOnBackdrop="false"
    :zIndex="zIndex"
    :blurBackdrop="false"
    :backdropOpacity="0.3"
    @close="emit('close')"
  >
    <template #body>
      <div class="body">
        <small class="message">{{ message }}</small>
      </div>
    </template>

    <template #footer>
      <Button variant="secondary" size="md" block :disabled="isLoading" @click="emit('close')">
        {{ cancelText }}
      </Button>
      <Button
        :variant="confirmVariant"
        size="md"
        block
        :loading="isLoading"
        :disabled="isLoading"
        @click="emit('confirm')"
      >
        {{ confirmText }}
      </Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Button, Modal } from "@/components/ui";
import type { Variant } from "@/components/ui/types";

defineOptions({
  name: "ActionConfirmationModal",
});

interface Props {
  show: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: Variant;
  isLoading?: boolean;
  zIndex?: number;
  dialogMaxWidth?: string;
}

withDefaults(defineProps<Props>(), {
  title: "Are you sure?",
  message: "Please confirm this action.",
  confirmText: "Confirm",
  cancelText: "Cancel",
  confirmVariant: "danger",
  isLoading: false,
  zIndex: 10080,
  dialogMaxWidth: "400px",
});

const emit = defineEmits<{
  close: [];
  confirm: [];
}>();
</script>

<style scoped>
.body {
  padding: 12px 20px 16px;
}

.message {
  font-weight: 400;
  font-size: 0.8rem;
  color: #6f6c90;
  display: block;
}

:deep(.ui-modal__footer) {
  gap: 12px;
}

:deep(.ui-modal__footer .ui-button) {
  flex: 1;
}
</style>
